module.exports = __webpack_public_path__ + "img/spain-lung-cancer-female.c240b0de.png";